var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Model } from 'vue-property-decorator';
var RelationCheckbox = /** @class */ (function (_super) {
    __extends(RelationCheckbox, _super);
    function RelationCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.indeterminate = false;
        _this.checkAll = false;
        return _this;
    }
    RelationCheckbox.prototype.onChange = function (val) { };
    Object.defineProperty(RelationCheckbox.prototype, "checkedModel", {
        get: function () {
            if (this.checkedRelation.length === 0) {
                this.indeterminate = false;
                this.checkAll = false;
            }
            return this.checkedRelation;
        },
        set: function (val) {
            this.onChange(val);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RelationCheckbox.prototype, "relations", {
        get: function () {
            return this.$dict.getDictData('Relationship');
        },
        enumerable: false,
        configurable: true
    });
    RelationCheckbox.prototype.handleCheckAllChange = function (val) {
        var arr = !val ? [] : this.relations.map(function (e) { return e.code; });
        this.onChange(arr);
        this.indeterminate = false;
    };
    RelationCheckbox.prototype.handleCheckedRealtionChange = function (val) {
        this.onChange(val);
        var count = val.length;
        this.checkAll = count === this.relations.length;
        this.indeterminate = count > 0 && count < this.relations.length;
    };
    __decorate([
        Model('on-change')
    ], RelationCheckbox.prototype, "checkedRelation", void 0);
    __decorate([
        Emit('on-change')
    ], RelationCheckbox.prototype, "onChange", null);
    RelationCheckbox = __decorate([
        Component({})
    ], RelationCheckbox);
    return RelationCheckbox;
}(Vue));
export default RelationCheckbox;
